import {configureStore} from "@reduxjs/toolkit";
import adminUserDetailsReducer from "./reducer.js";
import {apiSlice} from "./apiSlice.js";

export const store = configureStore({
    reducer: {
        admin: adminUserDetailsReducer, // clean key name
        [apiSlice.reducerPath]: apiSlice.reducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(apiSlice.middleware),
});
